
import React, { useState, useEffect } from "react";
import { BASE_URL } from "../../../constants";
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
//import {Row, Col, Container, Card} from 'react-bootstrap';
import { Row, Col, Container, Card, Button, InputGroup } from 'react-bootstrap';
import '../../../CommonCSS/SocietyCSS.css';


// import Select from 'react-select';

const Classwise_Subject = () => {

  const [isEditable, setIsEditable] = useState(false);
  const [dropdowns, setDropdowns] = useState({ premTypes: [], mainComp: [] });
  const [ddlStandards, setDdlStandards] = useState([]);
  const [ddlDivisions, setDdlDivisions] = useState([]);

  // Header State
  const [headerData, setHeaderData] = useState({
    std_id: '',
    div_id: '',
    year1: '',
    year2: '',
    sub_id: '',
    exam_name: '',
    mthly_fee_pd_till: '',
    inst_fee_pd_till: '',
  });

  const [savedfromDate, setSavedFromDate] = useState('');
  const [savedendDate, setSavedEndDate] = useState('');
  const [savedYear1, setSavedYear1] = useState('');

  // Child Table Data
  const [childRows, setChildRows] = useState([
    {
      subject_id: '',
      exam_date: '',
      from_time: '',
      to_time: '',
    }
  ]);

  const handleHeaderChange = (e) => {
    const { name, value } = e.target;
    setHeaderData(prev => ({ ...prev, [name]: value }));
  };

  const handleChildChange = (index, e) => {
    const { name, value } = e.target;
    const updatedRows = [...childRows];
    updatedRows[index][name] = value;
    setChildRows(updatedRows);
  };


 useEffect(() => {

    const fetchStandards = async () => {
      try {
         const stdresult = await axios.get(`${BASE_URL}/api/ddl_all_standards`);
      setDdlStandards(stdresult.data);

      } catch (error) {
        console.error("Error fetching subgroups:", error);
      }
    };

    fetchStandards();

  }, []);

  /// To Populate Division on change of Standard
  useEffect(() => {

    if (!headerData.std_id) return;

    const fetchDivision = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/api/ddl_division`, { params: { p_Std_Id: headerData.std_id } });
        setDdlDivisions(res.data || []);
      } catch (error) {
        console.error("Error fetching subgroups:", error);
      }
    };

    fetchDivision();

  }, [headerData.std_id]);

  const addRow = () => {
    const newIndex = childRows.length + 1; // 1-based index
    const newRow = {
      parent_irn: '',
      maintId: '',
      dispOrder: newIndex, // Default to index + 1
      amount: ''
    };
    setChildRows([...childRows, newRow]);
    //setChildRows([...childRows, { parent_irn: '', maintId: '', dispOrder: '', amount: '' }]);
  };

  const removeRow = (index) => {
    const updatedRows = [...childRows];
    updatedRows.splice(index, 1);
    setChildRows(updatedRows);
  };

  const handleNew = () => {
    setIsEditable(true);
    setHeaderData({
      std_id: '',
      div_id: '',
      year1: '',
      year2: '',
      sub_id: '',
      exam_name: '',
      mthly_fee_pd_till: '',
      inst_fee_pd_till: '',
    });
    setChildRows([{
      subject_id: '',
      exam_date: '',
      from_time: '',
      to_time: '',
    }]);
  };

  const handleSave = async () => {

    // if (!headerData.fromDate || !headerData.toDate) {
    //   //speakMessage('From or To Date cannot be left blank.');
    //   alert('From or To Date cannot be left blank !');
    //   return;
    // }
    // else if (headerData.fromDate > headerData.toDate) {
    //   //speakMessage('From cannot be greater than To Date.');
    //   alert('From cannot be greater than To Date !');
    //   return;
    // }
    // else if (!headerData.premiseType || headerData.premiseType === '') {
    //   //speakMessage('Please Select Premise Type');
    //   alert('Please Select Premise Type !');
    //   return;
    // }

    let lv_err_msg = '';

    for (let i = 0; i < childRows.length; i++) {
      if (!childRows[i].maintId || childRows[i].maintId === '') {
        lv_err_msg = 'Please Select Maintenance Component at Row # ' + (i + 1);
        break;
      }
      else if (!childRows[i].dispOrder || childRows[i].maintId === '0') {
        lv_err_msg = 'Please enter Display Order at Row # ' + (i + 1);
        break;


      }
      else if (!childRows[i].amount || childRows[i].amount === '0' || childRows[i].amount < 0) {
        lv_err_msg = 'Please enter Maintenance Amount greater than 0 at Row # ' + (i + 1);
        break;
      }

    }

    if (lv_err_msg) {
      alert(lv_err_msg);
      return;
    }

    let lv_dupl = 0;

    for (let i = 0; i < childRows.length; i++) {
      for (let j = i + 1; j < childRows.length; j++) {
        if (childRows[i].maintId === childRows[j].maintId) {
          lv_dupl = j;
          break;
        }
      }
      if (lv_dupl > 0) {
        break;
      }
    }

    if (lv_dupl > 0) {
      playBeep();
      alert('Duplicate Maintenance Component selected at Row # ' + (lv_dupl + 1));
      return;
    }

    // DB Validation to check if the given From/To dates, Premise Type already exists or not

    const valResp = await axios.get(`${BASE_URL}/api/validate_maint_struct`,
      { params: { p_Year1: savedYear1, p_fromDate: headerData.fromDate, p_toDate: headerData.toDate, p_PremTypeId: headerData.premiseType } });

    if (valResp.data[0].rows_count > 0) {
      playBeep();
      //speakMessage('Maintenance Structure already exists for the given Year, From, To Dates and Premise Type');
      alert('Maintenance Structure already exists for the given Year, From, To Dates and Premise Type !');
      return;
    }

    // console.log('valResp.data ===> ', valResp.data); 
    // console.log('valResp.data[0].rows_count ===> ', valResp.data[0].rows_count); 

    const isConfirmed = window.confirm("Sure you want to Save the record ?");

    if (!isConfirmed) return;

    const structdata = {
      header: headerData,
      details: childRows,
    };

    const response = await axios.post(`${BASE_URL}/api/save_maint_struct`, structdata);

    if (response.data.message === '1') {
      //alert('Maintenance Structure saved successfully !');
      speakMessage('Maintenance Structure saved successfully. Do you like to Add more ?');
      if (window.confirm("Maintenance Structure saved successfully. Do you like to Add more ?")) {
        //headerData.premiseType = '';
        //setDropdowns.premTypes('');
        const updatedChildRows = childRows.map(row => ({
          ...row,
          amount: ''
        }));
        setChildRows(updatedChildRows);
      }
      else {
        setIsEditable(false);
        setHeaderData({
          std_id: '',
          div_id: '',
          year1: '',
          year2: '',
          sub_id: '',
          exam_name: '',
          mthly_fee_pd_till: '',
          inst_fee_pd_till: '',
        });
        setChildRows([{
          subject_id: '',
          exam_date: '',
          from_time: '',
          to_time: '',
        }]);
        headerData.fromDate = savedfromDate;
        headerData.toDate = savedendDate;
      }
    }

  };

  const handleClear = () => {
    if (window.confirm("Clear all data?")) {
      handleNew();
      setIsEditable(false);
    }
  };

  const playBeep = () => {
    const audioCtx = new (window.AudioContext || window.AudioContext)();
    const oscillator = audioCtx.createOscillator();
    const gainNode = audioCtx.createGain();

    oscillator.connect(gainNode);
    gainNode.connect(audioCtx.destination);

    oscillator.type = 'square'; // Other types: sine, square, triangle, sawtooth
    oscillator.frequency.setValueAtTime(440, audioCtx.currentTime); // Frequency in Hz (440Hz = A4 note)
    gainNode.gain.setValueAtTime(0.1, audioCtx.currentTime); // Volume

    oscillator.start();
    oscillator.stop(audioCtx.currentTime + 0.2); // Play for 0.2 seconds
  };

  const speakMessage = (message) => {
    const utterance = new SpeechSynthesisUtterance(message);
    utterance.lang = 'en-US'; // or 'en-GB', 'hi-IN', etc.
    utterance.rate = 1;       // Speed: 0.1 (slow) to 10 (fast)
    utterance.pitch = 1;      // Pitch: 0 to 2
    speechSynthesis.speak(utterance);
  };

  return (
    <Container fluid className="p-3">
      <Card className="mb-4 p-3">



        {<Row className="mb-3">

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "90px" }}>
                Standard
              </InputGroup.Text>
              <select
                className="form-select"
                name="std_id"
                value={headerData.std_id}
                disabled={!isEditable}
                onChange={(e) => handleHeaderChange(e)}
              >
                <option value="">-- Select Standard--</option>
                 {ddlStandards.map(std => (
                  <option key={std.std_id} value={std.std_id}>{std.std_name}</option>
                ))}

              </select>
            </InputGroup>
          </Col>


          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "90px" }}>
                Division
              </InputGroup.Text>
              <select
                className="form-select"
                name="div_id"
                value={headerData.div_id}
                disabled={!isEditable}
                onChange={(e) => handleHeaderChange(e)}
              >
                <option value="">-- Select Division--</option>
               {ddlDivisions.map(div => (
                    <option key={div.div_id} value={div.div_id}>{div.div_name}</option>
                  ))}

              </select>
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "90px" }}>
                Year 1
              </InputGroup.Text>
              <input
                type="text"
                style={{ textAlign: 'right' }}
                className="form-control"
                name="year1"
                value={headerData.year1}
                disabled={!isEditable}
              // onChange={handleChange}
              />
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "90px" }}>
                Year 2
              </InputGroup.Text>
              <input
                type="text"
                style={{ textAlign: 'right' }}
                className="form-control"
                name="year2"
                value={headerData.year2}
                disabled={!isEditable}
              // onChange={handleChange}
              />
            </InputGroup>
          </Col>

        </Row>}

        <Row className="mb-3">

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "110px" }}>
                Exam Name
              </InputGroup.Text>
              <select
                className="form-select"
                name="exam_name"
                value={headerData.exam_name}
                disabled={!isEditable}
              // onChange={handleChange}UNIT
              >
                <option value="">-- Select Exam--</option>
                <option value="UNIT-1">Unit Test-1</option>
                <option value="SEMESTER-1">Semester-1</option>
                <option value="UNIT-2">Unit Test-2</option>
                <option value="SEMESTER-2">Semester-2</option>
                <option value="PRELIUM-1">Prelium-1</option>
                <option value="PRELIUM-2">Prelium-2</option>
              </select>
            </InputGroup>
          </Col>

          <Col md={4}>
            <InputGroup>
              <InputGroup.Text style={{ width: "180px" }}>
                Monthly Fees Paid Till
              </InputGroup.Text>
              <select
                className="form-select"
                name="mthly_fee_pd_till"
                value={headerData.mthly_fee_pd_till}
                disabled={!isEditable}
              // onChange={handleChange}
              >
                <option value="0">-- Select Month--</option>
                <option value="1">January</option>
                <option value="2">February</option>
                <option value="3">March</option>
                <option value="4">April</option>
                <option value="5">May</option>
                <option value="6">June</option>
                <option value="7">July</option>
                <option value="8">Auiust</option>
                <option value="9">September</option>
                <option value="10">October</option>
                <option value="11">November</option>
                <option value="12">December</option>

              </select>
            </InputGroup>
          </Col>

          <Col md={4}>
            <InputGroup>
              <InputGroup.Text style={{ width: "160px" }}>
                Installment Paid Till
              </InputGroup.Text>
              <select
                className="form-select"
                name="inst_fee_pd_till"
                value={headerData.inst_fee_pd_till}
                disabled={!isEditable}
              // onChange={handleChange}
              >
                <option value="">-- Select Installment--</option>
                <option value="1">Installment-1</option>
                <option value="2">Installment-2</option>
                <option value="3">Installment-3</option>
                <option value="4">Installment-4</option>
                <option value="5">Installment-5</option>
                <option value="6">Installment-6</option>

              </select>
            </InputGroup>
          </Col>

        </Row>

         <div className="d-flex justify-content-end gap-2 mt-3 flex-wrap">

          <button
            type="button"
            className="btn btn-primary"
            style={{ width: "135px" }}
            onClick={handleNew}
            disabled={isEditable}
          >New
          </button>

          <button
            type="button"
            className="btn btn-secondary"
            style={{ width: "135px" }}
            onClick={handleClear}
          > Clear
          </button>

          <button
            type="button"
            className="btn btn-success"
            style={{ width: "135px" }}
            onClick={handleSave}
            disabled={!isEditable}
          > Save
          </button>
        </div> 
      </Card>

      {/* Child Table */}

      <Card className="p-3">
        <div style={{ minHeight: '220px' }} className="table-wrapper">
          <table style={{ maxHeight: '35px' }} className="responsive-table scty-custom-table">
            <thead>
              <tr>
                <th style={{ width: '2%', textAlign: 'center' }}>#</th>
                <th style={{ width: '10%', textAlign: 'left' }}>Subjects</th>
                <th style={{ width: '5%', textAlign: 'left' }}>Exam Date</th>
                <th style={{ width: '4%', textAlign: 'left' }}>From Time</th>
                <th style={{ width: '4%', textAlign: 'left' }}>To Time</th>
              </tr>
            </thead>

            <tbody>
              {childRows.map((row, index) => (
                <tr key={index}>
                  <td style={{ width: "5%", textAlign: 'center' }}>{index + 1}</td>

                  <td>
                    <input style={{ textAlign: 'left' }} disabled={!isEditable}
                      type="text" className="form-control" name="subject_id" value={row.subject_id} onChange={(e) => handleChildChange(index, e)} />
                  </td>
                  <td>
                    <input style={{ textAlign: 'left' }} disabled={!isEditable}
                      type="date" className="form-control" name="exam_date" value={row.exam_date} onChange={(e) => handleChildChange(index, e)} />
                  </td>
                  <td>
                    <input style={{ textAlign: 'left' }} disabled={!isEditable}
                      type="time" className="form-control" name="from_time" value={row.from_time} onChange={(e) => handleChildChange(index, e)} />
                  </td>
                  <td>
                    <input style={{ textAlign: 'left' }} disabled={!isEditable}
                      type="time" className="form-control" name="to_time" value={row.to_time} onChange={(e) => handleChildChange(index, e)} />
                  </td>

                  {/* <td style={{ textAlign: 'center' }}>
                    {childRows.length > 1 && (
                      <Button variant="danger" onClick={() => removeRow(index)} size="sm">Delete</Button>
                    )}
                  </td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* <div className="mb-3">
          <Button disabled={!isEditable} style={{ marginTop: '10px' }} variant="primary" onClick={addRow}>Add Row</Button>
        </div> */}
      </Card>

      {/* Buttons */}
    </Container>
  );
};

export default Classwise_Subject;
